import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';
import { logout, isTokenExpired } from './utils/auth';
import Login from './Login';
import Talika from './Talika';
import Brahmand from './Brahmand';
import { FiLogOut } from 'react-icons/fi';
import './App.css'; // Global app styling

const App = () => {
  const [token, setToken] = useState(null);

  // Load token from localStorage on mount
  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
    }
  }, []);

  // If token is expired, force logout
  useEffect(() => {
    if (token && isTokenExpired(token)) {
      handleLogout();
    }
  }, [token]);

  const handleLogin = (newToken) => {
    setToken(newToken);
    localStorage.setItem('token', newToken);
  };

  const handleLogout = () => {
    logout(); // Clears storage, etc.
    setToken(null);
  };

  // If no token, show the Login screen only
  if (!token) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <Router>
      <div className="App">
        
        {/* ======== TOP-RIGHT ICONS ======== */}
        <div className="top-right-icons"  style={{
          // position: "absolute",
          top: 20,
          right: 10,
        }}>

        <button className="logout-button" onClick={handleLogout} style={{ marginLeft: '10px' }}>
          <FiLogOut size={20} />
        </button>
        </div>

        {/* ======== ROUTES ======== */}
        <Routes>
          {/* Home => Brahmand */}
          <Route path="/" element={<Brahmand />} />

          {/* Talika => Table page */}
          <Route path="/talika" element={<Talika token={token} />} />

          {/* Catch-all redirect to Home (Optional) */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;